/* eslint-disable @typescript-eslint/no-explicit-any */

// 10 кадров при 60 герцах
var DEFAULT_WAIT = 166;

/**
 * Минималистичная реализация алгоритма debounce
 *
 * @export
 * @template T
 * @param {T} func
 * @param {*} [wait=166]
 * @return {*}  {(T & ICancelable)}
 */
export function debounce(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_WAIT;
  var timeout;
  function debounced() {
    var _this = this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var later = function later() {
      // @ts-expect-error any
      func.apply(_this, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }
  debounced.cancel = function () {
    clearTimeout(timeout);
  };
  return debounced;
}